module.exports = {"540326100":"白玛镇","540326101":"帮达镇","540326102":"然乌镇","540326103":"同卡镇","540326202":"郭庆乡","540326203":"拉根乡","540326204":"益庆乡","540326205":"吉中乡","540326206":"卡瓦白庆乡","540326207":"吉达乡","540326208":"夏里乡","540326209":"拥乡","540326210":"瓦乡","540326211":"林卡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540326.json
// module id = 2847
// module chunks = 0